<template>
    <div class="col-sm-4">
        <div class="investment-group"><span class="invest-lable">+15.4%</span>
            <div class="gain-chart" id="gain-chart">
                <apexchart type="line" height="108" :options="invest.options" :series="invest.series">
                </apexchart>
            </div>
            <div class="chart-detail">
                <h5>Total Gain</h5>
                <h2>$7454.25</h2>
            </div>
        </div>
    </div>
</template>
<script>
var secondary = localStorage.getItem('secondary_color') || '#FFA47A';
export default {
    name: 'investPage',
    data() {
        return {
            invest: {
                options: {
                    chart: {
                        height: 108,
                        type: "line",
                        zoom: {
                            enabled: false,
                        },
                        toolbar: {
                            show: false,
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    stroke: {
                        curve: "smooth",
                    },
                    legend: {
                        show: false,
                    },
                    grid: {
                        show: false,
                    },
                    colors: [secondary],
                    xaxis: {
                        axisBorder: {
                            show: false,
                        },
                        labels: {
                            show: false,
                        },
                        axisTicks: {
                            show: false,
                        },
                        crosshairs: {
                            show: true,
                            width: 1,
                            position: "back",
                            stroke: {
                                color: secondary,
                                width: 1,
                                dashArray: 5,
                            },
                        },
                        tooltip: {
                            enabled: false,
                        },
                    },
                    yaxis: {
                        labels: {
                            show: false,
                        },
                    },
                    tooltip: {
                        marker: {
                            show: false,
                        },
                        fixed: {
                            enabled: false,
                            position: "bottomRight",
                            offsetX: 0,
                            offsetY: 0,
                        },
                    },
                },
                series: [
                    {
                        name: "Desktops",
                        data: [20, 10, 20, 10, 20, 15, 25],
                    },
                ],
            }
        }
    }
}
</script>
